// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__wA30f","col":"styles_col__rMj08"};